__turbopack_context__.v({
  "header": "hbovya_header",
  "logo": "hbovya_logo",
});
